// GENERATED by scripts/gen-tokens.mjs from frontend/lib/core/theme — do not edit.

export const darkPalette = {
  "brand": "#3468E4",
  "brandMuted": "#5B95FA",
  "brandLight": "#A9C6FB",
  "brandDeep": "#173E9E",
  "brandVivid": "#5A7BF2",
  "brandBlue": "#1C4BBF",
  "brandSubtle": "rgba(52, 104, 228, 0.141)",
  "onBrand": "#F2F5FA",
  "aiSky": "#A9C6FB",
  "aiBlue": "#5B95FA",
  "aiViolet": "#A78BFA",
  "aiTeal": "#2DD4BF",
  "background": "#09101A",
  "surface": "#121C2C",
  "surfaceElevated": "#162337",
  "surfaceSunken": "#0B131E",
  "border": "#1F2E46",
  "borderStrong": "#34486A",
  "textPrimary": "#F2F5FA",
  "textSecondary": "#8E99AF",
  "textTertiary": "#6F7A90",
  "textDisabled": "#4C566A",
  "positive": "#34D399",
  "positiveSubtle": "rgba(52, 211, 153, 0.141)",
  "negative": "#F87171",
  "negativeSubtle": "rgba(248, 113, 113, 0.141)",
  "warning": "#FBBF24",
  "warningSubtle": "rgba(251, 191, 36, 0.141)",
  "info": "#C6CEDC",
  "infoSubtle": "rgba(255, 255, 255, 0.078)",
  "overlay": "rgba(255, 255, 255, 0.059)",
  "scrim": "rgba(0, 0, 0, 0.702)"
} as const;
export const lightPalette = {
  "brand": "#1D4ED8",
  "brandMuted": "#2563EB",
  "brandLight": "#8FB2FA",
  "brandDeep": "#1E3A8A",
  "brandVivid": "#4F6FEF",
  "brandBlue": "#1E40AF",
  "brandSubtle": "rgba(29, 78, 216, 0.078)",
  "onBrand": "#FFFFFF",
  "aiSky": "#1E40AF",
  "aiBlue": "#2563EB",
  "aiViolet": "#7C3AED",
  "aiTeal": "#0D9488",
  "background": "#F5F7FB",
  "surface": "#FFFFFF",
  "surfaceElevated": "#FFFFFF",
  "surfaceSunken": "#EEF1F7",
  "border": "#E0E5EE",
  "borderStrong": "#C6CEDB",
  "textPrimary": "#121A27",
  "textSecondary": "#596377",
  "textTertiary": "#8791A5",
  "textDisabled": "#B1B9C8",
  "positive": "#059669",
  "positiveSubtle": "rgba(5, 150, 105, 0.078)",
  "negative": "#DC2626",
  "negativeSubtle": "rgba(220, 38, 38, 0.078)",
  "warning": "#B45309",
  "warningSubtle": "rgba(180, 83, 9, 0.078)",
  "info": "#596377",
  "infoSubtle": "rgba(0, 0, 0, 0.039)",
  "overlay": "rgba(0, 0, 0, 0.059)",
  "scrim": "rgba(0, 0, 0, 0.4)"
} as const;
export type PaletteKey = keyof typeof darkPalette;
export const space = {"xxs":2,"xs":4,"sm":8,"md":12,"lg":16,"xl":20,"xxl":24,"xxxl":32,"huge":48,"navClearance":96} as const;
export const radii = {"xxs":2,"xs":6,"sm":8,"md":12,"lg":16,"xl":20,"pill":999} as const;
export const typeScale = {"display":32,"title":24,"headline":20,"subtitle":17,"body":15,"callout":14,"caption":13,"micro":11,"nano":10,"pico":9,"tightHeight":1.15,"normalHeight":1.35,"looseHeight":1.5} as const;
export const breakpoints = {"compact":600,"medium":900,"expanded":1200} as const;
export const motionMs = {"instant":90,"fast":160,"normal":240,"deliberate":500,"candleFormation":9000,"ring":6000,"aiGlow":3000} as const;
